export const clpLabelDropDownLearnMoreButtonText = "tNb";
export const clpLabelDropDownLearnMoreButtonToolTipText = "uNb";
export const clpLabelCannotChangeLabelModalTitle = "vNb";
export const clpLabelCannotChangeLabelModalSubtext = "wNb";
export const clpLabelCannotChangeLabelWithCloudAttachment = "xNb";
export default {clpLabelDropDownLearnMoreButtonText,clpLabelDropDownLearnMoreButtonToolTipText,clpLabelCannotChangeLabelModalTitle,clpLabelCannotChangeLabelModalSubtext,clpLabelCannotChangeLabelWithCloudAttachment};